export const MapLocGroupConstants = {
    GET_MAP_GROUP: 'GET_MAP_GROUP',
    SET_MAP_GROUP: 'SET_MAP_GROUP'
};